import { render } from "./CollapseCard.vue?vue&type=template&id=1b7ada70&scoped=true"
import script from "./CollapseCard.vue?vue&type=script&lang=js"
export * from "./CollapseCard.vue?vue&type=script&lang=js"

import "./CollapseCard.scss?vue&type=style&index=0&id=1b7ada70&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7ada70"]])

export default __exports__